import BasketSummarySFC from "./BasketSummary.vue";
export type { IBasketSummaryProps } from "./props";
export const BasketSummary = BasketSummarySFC;
